import {
  GET_UNITMEASURE,
  GET_UNITMEASURE_FAIL,
  GET_UNITMEASURE_SUCCESS,
  GET_UNITMEASURES,
  GET_UNITMEASURES_FAIL,
  GET_UNITMEASURES_SUCCESS,
  ADD_NEW_UNITMEASURE,
  ADD_UNITMEASURE_SUCCESS,
  ADD_UNITMEASURE_FAIL,
  UPDATE_UNITMEASURE,
  UPDATE_UNITMEASURE_SUCCESS,
  UPDATE_UNITMEASURE_FAIL,
  DELETE_UNITMEASURE,
  DELETE_UNITMEASURE_SUCCESS,
  DELETE_UNITMEASURE_FAIL,
  SET_STATE_UNITMEASURE,
  UPDATE_UNITMEASURE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_UNITMEASURE,
  payload: loading,
})

export const getUnitMeasures = ( params ) => ({
  type: GET_UNITMEASURES,
  payload: { params },
})

export const getUnitMeasuresSuccess = (unitmeasures, totalPages, currentPage) => ({
  type: GET_UNITMEASURES_SUCCESS,
  payload: {unitmeasures:unitmeasures,total:totalPages, currentPage:currentPage}
})

export const getUnitMeasuresFail = error => ({
  type: GET_UNITMEASURES_FAIL,
  payload: error,
})

export const addNewUnitMeasure = unitmeasure => ({
  type: ADD_NEW_UNITMEASURE,
  payload: unitmeasure,
})

export const addUnitMeasureSuccess = unitmeasure => ({
  type: ADD_UNITMEASURE_SUCCESS,
  payload: unitmeasure,
})  

export const addUnitMeasureFail = error => ({
  type: ADD_UNITMEASURE_FAIL,
  payload: error,
})

export const updateUnitMeasure = unitmeasure => ({
  type: UPDATE_UNITMEASURE,
  payload: unitmeasure,
})

export const updateUnitMeasureStatus = unitmeasure => ({
  type: UPDATE_UNITMEASURE_STATUS,
  payload: unitmeasure,
})

export const updateUnitMeasureSuccess = unitmeasure => ({
  type: UPDATE_UNITMEASURE_SUCCESS,
  payload: unitmeasure,
})

export const updateUnitMeasureFail = error => ({
  type: UPDATE_UNITMEASURE_FAIL,
  payload: error,
})

export const deleteUnitMeasure = unitmeasure => ({
  type: DELETE_UNITMEASURE,
  payload: unitmeasure,
})

export const deleteUnitMeasureSuccess = id => ({
  type: DELETE_UNITMEASURE_SUCCESS,
  id,
})

export const deleteUnitMeasureFail = error => ({
  type: DELETE_UNITMEASURE_FAIL,
  payload: error,
})

export const getUnitMeasure = () => ({
  type: GET_UNITMEASURE,
})

export const getUnitMeasureSuccess = unitmeasure => ({
  type: GET_UNITMEASURE_SUCCESS,
  payload: unitmeasure,
})

export const getUnitMeasureFail = error => ({
  type: GET_UNITMEASURE_FAIL,
  payload: error,
})
